/**
 * @file index.js
 * @fileOverview React App loader with IE fix
 * @author Smartmatic
 * @creationDate 2018-08-01
 * @modificationDate 2025-03-05
 */
import React, { Suspense, lazy } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import { initializeCSS } from './utils/cssHelpers';
import { throttleTabbing, throttleSelectUpAndDown } from './utils/accessibilityHelpers';
import { getLoadingScreen } from './utils/loadingHelpers';
import { IS_DEV } from './utils/process';

if (!IS_DEV) {
  // lazy load fix for IE from https://github.com/Financial-Times/polyfill-library/issues/163
  // eslint-disable-next-line
  Object.prototype[Symbol.toStringTag] = Object.prototype[Symbol.toStringTag];
}

const App = lazy(() => import('./App'));

initializeCSS();

throttleTabbing();
throttleSelectUpAndDown();

const root = createRoot(document.getElementById('root'));
root.render(
  <Suspense fallback={getLoadingScreen(window.location.pathname, true)}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Suspense>
);
